import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra de compra fija para móvil. Aparece una vez que el hero quedó atrás y
 * se oculta al llegar al footer para no interferir con la navegación.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const scrolledPastHero = window.scrollY > window.innerHeight * 0.85;
      const footer = document.getElementById('site-footer');
      const footerReached = footer ? footer.getBoundingClientRect().top <= window.innerHeight : false;
      setVisible(scrolledPastHero && !footerReached);
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-stone bg-ivory/95 backdrop-blur transition-transform duration-300 md:hidden ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-316" data-mp="2iemeb7mcmjwf">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5" data-id="element-317" data-mp="2x651pqhjfgpt">
        <div className="min-w-0" data-id="element-318" data-mp="323wvkq1qtcwn">
          <p className="truncate font-sans text-[0.66rem] font-medium uppercase tracking-[0.12em] text-charcoal/60" data-id="element-319" data-mp="36505kvx40epy">
            Método Consultorio Rentable
          </p>
          <p className="font-sans text-lg font-bold leading-tight tracking-tight tabular-nums text-charcoal" data-id="element-320" data-mp="17r6wltwipdie">
            {PRICE.current}
          </p>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} tabIndex={visible ? 0 : -1} className="flex min-h-[44px] max-w-[10.5rem] shrink-0 items-center justify-center rounded-full bg-gold px-4 py-2 text-center font-sans text-[0.6rem] font-bold uppercase leading-[1.15] tracking-[0.1em] text-ivory transition-colors hover:bg-gold-deep focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50" data-id="element-321" data-mp="2f2xyiu75r8aq">
          Quiero acceder ahora
        </a>
      </div>
    </div>;
}